import APIConnector from './utils/APIConnector';

const Request = APIConnector.instance;
const ENDPOINT = '/image';

class ImagesAPI {
  static upload = image => {
    const data = new FormData();
    data.append('file', image);

    return Request.POST_FILE(`${ENDPOINT}/upload/do`, data);
  };
}

export default ImagesAPI;
